module.exports = __webpack_public_path__ + "img/title_long_bg02.5dbadad4.png";